import React, { useEffect, useRef } from "react";

/**
 * A very low-opacity blue/indigo wash that trails the cursor. Interpolated
 * slowly so it reads as atmosphere rather than as a circle following the mouse.
 * Desktop, fine-pointer, non-reduced-motion only.
 */
export default function CursorGlow() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const isFinePointer =
      window.matchMedia && window.matchMedia("(pointer: fine)").matches;
    if (reduceMotion || !isFinePointer) return;

    let tx = window.innerWidth / 2;
    let ty = window.innerHeight / 2;
    let x = tx;
    let y = ty;
    let rafId = null;
    let running = false;

    const step = () => {
      const dx = tx - x;
      const dy = ty - y;
      x += dx * 0.045;
      y += dy * 0.045;
      el.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;

      if (Math.abs(dx) < 0.4 && Math.abs(dy) < 0.4) {
        running = false;
        rafId = null;
        return;
      }
      rafId = requestAnimationFrame(step);
    };

    const wake = () => {
      if (running) return;
      running = true;
      rafId = requestAnimationFrame(step);
    };

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
      if (el.style.opacity !== "1") el.style.opacity = "1";
      wake();
    };

    const onLeave = () => {
      el.style.opacity = "0";
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    document.addEventListener("pointerleave", onLeave);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener("pointermove", onMove);
      document.removeEventListener("pointerleave", onLeave);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden="true"
      className="eb-cursor-glow"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "460px",
        height: "460px",
        borderRadius: "50%",
        background:
          "radial-gradient(circle, rgba(37, 99, 235, 0.055) 0%, rgba(79, 70, 229, 0.03) 42%, rgba(255, 255, 255, 0) 68%)",
        pointerEvents: "none",
        zIndex: 1,
        opacity: 0,
        transition: "opacity 0.6s ease",
        willChange: "transform",
      }}
    />
  );
}
